'use client'

import { Tag } from 'fukku/Tag'
import type { FiltersSearchParams } from 'plp/types/Catalog'
import type { Tag as TagType } from 'plp/types/Filters'

import styles from './Tags.module.scss'

export function Tags({
	tags,
	defaultFilter,
}: {
	tags: TagType[]
	defaultFilter?: FiltersSearchParams
}): React.ReactNode {
	return defaultFilter && tags?.length ? (
		<ul className={styles.tags}>
			{tags.map((tag) => (
				<li className={styles.tag} key={tag.label}>
					<Tag label={tag.label} />
				</li>
			))}
		</ul>
	) : null
}
